<div class="wb-container">
  <img src="assets/logo-taxiwebbooker.svg" alt="TaxiWebBooker"/>
  <div class="wb-no_contract_text"
       [innerHTML]="(contractStatus === 'email_not_validated' ? 'email_not_validated_notification' : 'no_contract_notification') | translate | ucFirst">
  </div>
</div>
